import React, { useState, useContext, useEffect } from 'react'
import styles from './DetailedWorkDetails.module.css'
import { FormTitle } from '../../../Common/FormTitle'
import { TextInput } from '../../../../Common/TextInput'
import { NextButton } from '../../../Common/CtaButton/NextButton'
import { ResumeAutoGenerateModal } from './ResumeAutoGenerateModal'
import { StepContext } from '../../StepContainer'
import { useAbTestGtm } from '../../../../../hooks/useAbTestGtm'
import {
    DETAILED_JOB_DETAILS_MAX_LENGTH,
    DETAILED_JOB_DETAILS_MIN_LENGTH,
} from '../../../../../constants/progressBanner'

export const DetailedWorkDetails = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    const { updateUserResume, formState } = useContext(StepContext)
    const [detailedJobDetails, setDetailedJobDetails] = useState<string>(
        formState.userResumesAttributes[0]?.detailedJobDetails || ''
    )
    const [isFormValid, setIsFormValid] = useState<boolean>(false)
    const [detailedJobDetailsError, setDetailedJobDetailsError] =
        useState<string>('')
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

    const validateDetailedJobDetails = (
        value: string,
        shouldShowError = false
    ) => {
        if (!value) {
            setDetailedJobDetailsError(
                shouldShowError ? '入力してください' : ''
            )
            return false
        }

        if (value.length < DETAILED_JOB_DETAILS_MIN_LENGTH) {
            setDetailedJobDetailsError(
                shouldShowError
                    ? `${DETAILED_JOB_DETAILS_MIN_LENGTH}文字以上入力してください`
                    : ''
            )
            return false
        }

        if (value.length > DETAILED_JOB_DETAILS_MAX_LENGTH) {
            setDetailedJobDetailsError(
                shouldShowError
                    ? `${DETAILED_JOB_DETAILS_MAX_LENGTH}文字以内で入力してください`
                    : ''
            )
            return false
        }

        setDetailedJobDetailsError('')
        return true
    }

    const validateForm = () => {
        const isValid = validateDetailedJobDetails(detailedJobDetails, false)
        setIsFormValid(isValid)
    }

    const handleDetailedJobDetailsChange = (value: string) => {
        setDetailedJobDetails(value)
        validateDetailedJobDetails(value, false)
        validateForm()
    }

    const handleDetailedJobDetailsBlur = () => {
        validateDetailedJobDetails(detailedJobDetails, true)
        validateForm()
    }

    useEffect(() => {
        validateForm()
    }, [detailedJobDetails])

    const handleAutoGenerateClick = () => {
        updateUserResume(0, 'resumeAuto', true)
        setIsModalOpen(true)
    }

    const handleGenerate = (generatedText: string) => {
        setDetailedJobDetails(generatedText)
        validateDetailedJobDetails(generatedText, false)
        validateForm()
    }

    return (
        <div className={styles.wrapper}>
            <div className={styles.selectionWrapper}>
                <div className={styles.monthbox}>
                    <FormTitle
                        formTitleText='詳しい仕事内容は？'
                        dataViewLabel={dataViewLabel(
                            'EF_StepForm_詳しい仕事内容'
                        )}
                        dataClickLabel={dataClickLabel(
                            'EF_StepForm_詳しい仕事内容-戻る'
                        )}
                    />
                </div>
                <img
                    src='/foodslaboEf/img/step14/balloon.png'
                    alt='スカウト情報'
                    className={styles.balloonImage}
                />
                <button
                    className={styles.autoGenerateButton}
                    onClick={handleAutoGenerateClick}
                    data-click-label={dataClickLabel(
                        'EF_StepForm_詳しい仕事内容-自動生成'
                    )}
                >
                    自動で文章を作成する
                    <img
                        src='/foodslaboEf/img/common/nextIcon.svg'
                        alt='次へ'
                        className={styles.nextIcon}
                    />
                </button>
                <p className={styles.overwriteDisclaimer}>
                    ※既に入力した職務経歴 (仕事内容) は上書きされます
                </p>
                <div className={styles.companyField}>
                    <TextInput
                        text='イタリアンレストランの○○店にて3年間接客や調理、仕込みなど基本的な現場業務に携わり、その後店長として3年間、売上げ管理や、アルバイト・新入社員のマネジメントやメニュー開発に従事。'
                        value={detailedJobDetails}
                        onChange={handleDetailedJobDetailsChange}
                        onBlur={handleDetailedJobDetailsBlur}
                    />
                    <div className={styles.errorMessagesWrapper}>
                        {detailedJobDetailsError && (
                            <p className={styles.errorMessages}>
                                {detailedJobDetailsError}
                            </p>
                        )}
                    </div>
                </div>
                <div className={styles.nextButtonWrapper}>
                    <NextButton
                        formKey={[
                            'userResumesAttributes',
                            'detailedJobDetails',
                        ]}
                        formValue={[0, detailedJobDetails]}
                        isDisabled={!isFormValid}
                        confirmation='次へ'
                        displayFormKey={'detailedJobDetails'}
                        displayFormValue={detailedJobDetails}
                        dataClickLabel={dataClickLabel(
                            'EF_StepForm_詳しい仕事内容-確認画面へ'
                        )}
                    />
                </div>
            </div>
            <ResumeAutoGenerateModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onGenerate={handleGenerate}
            />
        </div>
    )
}
